import { createAsyncThunk } from "@reduxjs/toolkit";

import { getSignupFormQuestions } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchSignupFormQuestions = createAsyncThunk(
  "signupFormQuestions/fetchSignupFormQuestions",
  async (params: Partial<{ config?: any }>, { getState, rejectWithValue }) => {
    try {
      const { config = {} } = params;
      const { adapter } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { token } = fetchAuthToken(getState());

      const response = await getSignupFormQuestions(token, baseUrl, config);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
